import { useEffect } from 'react'
import { useThree } from '@react-three/fiber'

/**
 * attach an event listener to the canvas object that cleans up after itself
 * and refreshes based on the passed dependencies
 *
 * @param handler the handler function to call when the event is triggered, should alwayys be memoized with useCallback
 * @param enabled optional boolean to enable/disable the listener
 */
const useCanvasEvent = <K extends keyof HTMLElementEventMap>(
  eventName: K,
  handler: (event: HTMLElementEventMap[K]) => void,
  enabled?: boolean,
) => {
  const gl = useThree(({ gl }) => gl)

  useEffect(() => {
    if (!enabled && enabled !== undefined) return

    gl.domElement.addEventListener(eventName, handler)
    return () => gl.domElement.removeEventListener(eventName, handler)
  }, [enabled, eventName, gl.domElement, handler])
}

export default useCanvasEvent
